import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';

@EntityTable('person', 'f518f306-26da-49b7-a68c-81edf678455c')
export class PersonEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public username: string;

    @Column(FieldTypeKind.STRING)
    public document: string;

    @Column(FieldTypeKind.STRING)
    public email: string;

    @Column(FieldTypeKind.STRING)
    public company: string;

    @Column(FieldTypeKind.TEXT)
    public bio: string;

    @Column(FieldTypeKind.FILE)
    public picture: any;

    @Column(FieldTypeKind.GUID)
    public userId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, true, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;
}
